import { FC } from "react";
import { Button, Stack, Text } from "@chakra-ui/react";

import { formatPriceWithoutZeros, isStringWithNumber } from "../../../../../utils";

interface Props {
  amount: string | undefined;
  onClose: () => void;
}

export const PaymentBlockOperationInProgressModal: FC<Props> = ({ amount, onClose }) => {
  const formattedAmount = isStringWithNumber(amount) ? formatPriceWithoutZeros(Number(amount)) : "";
  const text = formattedAmount
    ? `Операция на сумму ${formattedAmount} в обработке`
    : "Операция в обработке";

  return (
    <Stack pt="10px" px="4px" spacing={0}>
      <Text fontSize="14px" textAlign="center">{text}</Text>

      <Button onClick={onClose} mt="22px">Понятно</Button>
    </Stack>
  );
};
